import React from "react";
import createReactClass from "create-react-class";
import ModalContentBase from "../modal_content_base";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {
      prefKey: this.props.prefKey,
      isLoading: false,
    };
  },
  handlePrefChange(e) {
    this.setState({
      isLoading: true,
      prefKey: e.target.value,
    });
    this.props.onChangePref(e.target.value);
    this.modalContentBase.closeModal();
    this.setState({
      isLoading: false,
    });
  },
  render() {
    const currentPrefKey = this.state.prefKey;
    const currentPref = this.props.countryPrefs.find(function(pref) {
      return currentPrefKey == pref.pref_key;
    });

    const previewContent = (
      <div className="bg-white">
        <div className="search-box pr-3 pt-3 pb-3">
          <div className="row justify-content-between line-height-1 cursor-pointer">
            <p className="text-black-80 text-reset col-auto mb-0 icon icon-area icon-area-gray">
              {currentPref ? currentPref.name : "すべて"}
            </p>
          </div>
        </div>
      </div>
    );

    const countriesPrefs = this.props.countryPrefs.map((pref) => {
      return (
        <li className="nav-item p-3 border-bottom" key={pref.pref_key}>
          <input
            type="radio"
            name="pref"
            id={pref.pref_key}
            className="d-none checkbox__input checkbox__area"
            value={pref.pref_key}
            onChange={this.handlePrefChange}
            defaultChecked={pref.pref_key === currentPrefKey}
          />
          <label
            className="d-flex justify-content-between align-items-center mb-0 position-relative"
            htmlFor={pref.pref_key}
          >
            <span className="p-0 line-height-2 pl-3 mb-0">{pref.name}</span>
            <span className="checkbox__lg checkbox__noborder" />
          </label>
        </li>
      );
    });

    const modalContent = (
      <div className="card bg-gray pt-3">
        <button
          type="button"
          className="close close__modal position-absolute position--modalclose"
          aria-label="Close"
          onClick={this.closeModalPrefSelector}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h6 className="text-fw-bold text-center mb-3_5">
          地域を選択してください
        </h6>
        <div className="card bg-white h-100">
          <ul className="nav flex-column">{countriesPrefs}</ul>
        </div>
      </div>
    );

    return (
      <div
        style={{
        width: "30%",
        }}
        >
        <ModalContentBase
          previewContent={previewContent}
          modalContent={modalContent}
          ref={(c) => {
            this.modalContentBase = c;
          }}
        />
      </div>
    );
  },
});
